export default {"src":"/_next/static/media/image-icon.7b492790.svg","height":72,"width":72};